import { ORDER_STATUS_TEXT } from '@restaurant/constants';
import { OrderStatus } from '@restaurant/types';
import { Tag } from 'antd';
import React from 'react';

const statusColorMap = {
  [OrderStatus.Open]: 'processing',
  [OrderStatus.Closed]: 'success',
  [OrderStatus.Void]: 'error',
  [OrderStatus.Refund]: 'default',
};

const StatusTag = ({ value }: { value: OrderStatus }) => {
  return <Tag color={statusColorMap[value]}>{ORDER_STATUS_TEXT[value]}</Tag>;
};

export default StatusTag;
